import React from 'react';
import { Paper, Typography, Box, LinearProgress } from '@mui/material';
import { PlanDistribution } from '../../types/admin/AdminTypes';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';

interface PlanDistributionCardProps {
  plans: PlanDistribution[];
  onPlanClick?: (plan: string) => void;
}

const PlanDistributionCard: React.FC<PlanDistributionCardProps> = ({ plans, onPlanClick }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: '1px solid #e0e0e0',
        height: '100%'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <DonutLargeIcon sx={{ color: '#1976d2' }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Distribuição por Plano
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        {plans.map((plan) => (
          <Box
            key={plan.plan}
            sx={{
              flex: 1,
              minWidth: 140,
              p: 2,
              borderRadius: 2,
              backgroundColor: '#f8f9fa',
              cursor: onPlanClick ? 'pointer' : 'default',
              transition: 'all 0.2s',
              '&:hover': onPlanClick ? {
                backgroundColor: '#f0f0f0',
                transform: 'translateY(-2px)'
              } : {}
            }}
            onClick={() => onPlanClick?.(plan.plan)}
          >
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 700, 
                textAlign: 'center',
                color: plan.color 
              }}
            >
              {plan.count}
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              sx={{ textAlign: 'center', mt: 0.5 }}
            >
              {plan.plan}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={plan.percentage}
              sx={{
                mt: 2,
                height: 6,
                borderRadius: 3,
                backgroundColor: '#e0e0e0',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: plan.color,
                  borderRadius: 3
                }
              }}
            />
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                textAlign: 'center',
                mt: 1,
                color: '#1976d2',
                cursor: 'pointer',
                '&:hover': { textDecoration: 'underline' }
              }}
              onClick={(e) => {
                e.stopPropagation();
                onPlanClick?.(plan.plan);
              }}
            >
              Clique para ver detalhes →
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default PlanDistributionCard;
